import { AnyAction, Reducer } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  isAzam,
  ProduktDeleted,
  ReplaceState,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { App, FeatureToggles } from '@ps20-frontend/frontend-models';
import { Zahlungsart } from '@ps20/bff-models';
import {
  migrateAktionsnachlassAktion10, migrateAngebotsdatum,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { INITIAL_STATE } from '../initialState';
import { loadAndMigratePhState } from '../migrations';

export const rootReducer =
  (reducer: Reducer) =>
  (state: IAppState, action: AnyAction): IAppState => {
    switch (action.type) {
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.PH) {
          return actionPayload.appState;
        }
        return state;
      }
      case GlobalActions.SAVED_STATES_LOADED: {
        const newState = cloneDeep(state);
        const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
          .payload.savedStatesLoaded;
        const loadedAppState = actionPayload.find(loadedState => loadedState.appId === App.PH);
        if (loadedAppState != null) {
          if (isAzam(newState.transientState.role)) {
            delete loadedAppState.state.risikoort;
            delete loadedAppState.state.versicherungsnehmer.geburtsdatum;
            if (newState.vertragsoptionen?.zahlungsart === Zahlungsart.MAKLER_INKASSO) {
              delete loadedAppState.state.vertragsoptionen.zahlungsart;
            }
          }
          migrateAngebotsdatum(loadedAppState.state);
          migrateAktionsnachlassAktion10(
            loadedAppState.state,
            newState.transientState.featureToggles as FeatureToggles,
          );
          return loadAndMigratePhState(
            newState,
            loadedAppState.state,
            loadedAppState.state.vertragsoptionen?.beibehalten,
          );
        } else {
          return state;
        }
      }
      case GlobalActions.PRODUKT_DELETED: {
        const actionPayload: ProduktDeleted = action.payload;
        if (actionPayload.angebotsIds.some(angebotsId => angebotsId.appId === App.PH)) {
          const newState: IAppState = cloneDeep(INITIAL_STATE);
          newState.vertragsoptionen.zahlungsweise = state.vertragsoptionen.zahlungsweise;
          newState.vertragsoptionen.zahlungsart = state.vertragsoptionen.zahlungsart;

          newState.versicherungsnehmer.geburtsdatum = state.versicherungsnehmer.geburtsdatum;
          newState.versicherungsnehmer.isAssekuranztarif =
            state.versicherungsnehmer.isAssekuranztarif;
          newState.vorbelegungen = state.vorbelegungen;
          newState.risikoort = state.risikoort;
          newState.transientState.role = state.transientState.role;
          return newState;
        }
        return state;
      }
      default:
        return reducer(state, action);
    }
  };
